import { Padding } from "@mui/icons-material"

export const menuCont = {
    borderRadius: '8px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.02)',
    padding: "10px",
}

export const menuItem = {
    minWidth: "80px",
    display: "flex",
    flexDirection: "row",
    color: "primary.main",
    justifyContent: "start",
    alignItems: "center",
}